import { render, staticRenderFns } from "./batchpay.vue?vue&type=template&id=0a01a0f9&scoped=true"
import script from "./batchpay.vue?vue&type=script&lang=js"
export * from "./batchpay.vue?vue&type=script&lang=js"
import style0 from "./batchpay.vue?vue&type=style&index=0&id=0a01a0f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01a0f9",
  null
  
)

export default component.exports